// Shared helpers to describe an R-PAT assessment result: where it sits and how the learner did
export const rpatPath = (ctx) => (ctx ? [
    'R-PAT',
    ctx.phase_number ? `Phase ${ctx.phase_number}${ctx.phase_name ? ` · ${ctx.phase_name}` : ''}` : null,
    ctx.topic_title ? `${ctx.topic_number ? `Topic ${ctx.topic_number} · ` : ''}${ctx.topic_title}` : null,
] : []);

const STATUS = {
    passed: { label: 'Passed', tone: 'passed' },
    attempts_used_up: { label: 'Not passed · no attempts left', tone: 'failed' },
    in_progress: { label: 'Not passed yet', tone: 'pending' },
    not_started: { label: 'Not started', tone: 'neutral' },
};

export const rpatStatus = (s) => STATUS[s?.status] || STATUS.not_started;

export const attemptsText = (s) => (s?.max_attempts ? `${s.attempts_used} of ${s.max_attempts}` : `${s?.total_attempts ?? 0}`);

export const pct = (v) => (v == null ? null : `${Math.round(v)}%`);

export const shortDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }) : null);

export const rpatStatusDetails = (s) => [
    { label: 'Last score', value: pct(s?.last_score) },
    { label: 'Attempts used', value: attemptsText(s) },
    { label: 'Pass mark', value: pct(s?.pass_percentage) },
    { label: 'Last attempt', value: shortDate(s?.last_completed_at) },
];
